import { FunctionComponent, ReactNode } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useFieldRevert } from '../../_hooks/useFieldRevert';
import { FieldRevertButton } from '../FieldRevertButton/FieldRevertButton';
import { REVERT_SLOT_SPACING } from './FieldControlInputContainer.constant';

interface IFieldRevertRowProps {
  name: string;
  revertValue?: unknown;
  children: ReactNode;
}

const RevertSlot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open: boolean }>(({ theme, open }) => ({
  width: open ? theme.spacing(REVERT_SLOT_SPACING) : 0,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  transition: theme.transitions.create('width', {
    duration: theme.transitions.duration.shortest,
  }),
}));

// The field is full-width until it becomes dirty; then the slot grows and the field
// shrinks (smoothly, via the slot's width transition) to reveal the revert button.
export const FieldRevertRow: FunctionComponent<IFieldRevertRowProps> = ({ name, revertValue, children }) => {
  const { isDirty, revert } = useFieldRevert(name, revertValue);

  return (
    <>
      <Box
        data-field-dirty={isDirty ? 'true' : undefined}
        sx={{
          flexGrow: 1,
          minWidth: 0,
          overflow: 'hidden',
        }}>
        {children}
      </Box>
      <RevertSlot open={isDirty}>
        {isDirty && <FieldRevertButton onRevert={revert} />}
      </RevertSlot>
    </>
  );
};
